import React, { useMemo } from 'react';
import type { BulkOpsAnalyticsControllerContext } from '@atlassian/jira-bulk-operations-analytics/src/controllers/types.tsx';
import { ErrorFlag } from '@atlassian/jira-flags';
import type { FlagCustomRenderProps } from '@atlassian/jira-flags/src/services/types';
import { useIntl } from '@atlassian/jira-intl';
import { useFlagAnalytics } from '../../../../common/ui/use-flag-analytics/index.tsx';
import { useFormSubmitIssueIds } from '../../../../controllers/use-form-submit-state/main.tsx';
import { TEST_ID, FLAG_ID } from './constants.tsx';
import messages from './messages.tsx';

type Props = {
	onDismissed: () => void;
	bulkOpsFlow: BulkOpsAnalyticsControllerContext;
} & FlagCustomRenderProps;

export const OperationErrorFlag = ({ onDismissed, bulkOpsFlow, ...props }: Props) => {
	const { formatMessage } = useIntl();

	const issueIds = useFormSubmitIssueIds();

	const analyticsAttributes = useMemo(
		() => ({
			numSelectedCards: issueIds.length ?? 0,
			flagType: 'error',
		}),
		[issueIds.length],
	);

	useFlagAnalytics(analyticsAttributes, bulkOpsFlow);

	return (
		<ErrorFlag
			{...props}
			testId={TEST_ID}
			id={FLAG_ID}
			title={formatMessage(messages.title)}
			description={formatMessage(messages.description)}
			onDismissed={onDismissed}
			messageId="bulk-operations-common.ui.submit-status.flags.error-flag"
			messageType="transactional"
		/>
	);
};
